import type { ReactElement } from 'react';

import Spacings from '@dynatrace/strato-design-tokens/spacings';
import {
  CircleFilledIcon,
  DiamondFilledIcon,
  SquareFilledIcon,
  TriangleFilledIcon,
} from '@dynatrace/strato-icons';

import { BubbleShape } from './BubbleShape/BubbleShape.js';
import { MultiDataPointShape } from './MultiDataPointShape.js';
import { SingleDataPointShape } from './SingleDataPointShape.js';
import type { VariantShape } from './type.js';

interface ShapeIconProps {
  shape: VariantShape;
  color: string;
}

const iconBaseStyle = {
  width: Spacings.Size12,
  height: Spacings.Size12,
  display: 'block',
};

export function ShapeIcon(
  props: Readonly<ShapeIconProps>,
): ReactElement | null {
  switch (props.shape) {
    case 'circle':
      return (
        <CircleFilledIcon style={{ color: props.color, ...iconBaseStyle }} />
      );
    case 'single':
      return <SingleDataPointShape color={props.color} />;
    case 'square':
      return (
        <SquareFilledIcon style={{ color: props.color, ...iconBaseStyle }} />
      );
    case 'triangle':
      return (
        <TriangleFilledIcon style={{ color: props.color, ...iconBaseStyle }} />
      );
    case 'diamond':
      return (
        <DiamondFilledIcon style={{ color: props.color, ...iconBaseStyle }} />
      );
    case 'multi':
      return <MultiDataPointShape color={props.color} />;
    case 'bubble':
      return <BubbleShape color={props.color} />;
    default:
      return null;
  }
}
